<template>
    <div class="home-wrapper">

        <div class="container-fluid full-height home__bg">
            <div class="row h-100">
                <div class="col-xs-12 home__content">
                    <div class="home__logo">
                        <img class="logo" src="@/assets/ca_logo.svg">
                    </div>

                    <div class="login-form">
                        <b-form @submit.prevent="onSubmit()">
                            <div class="login-form__fields">
                                <b-form-group>
                                    <b-form-input
                                        v-model="form.email"
                                        type="email"
                                        class="tb-form-field login-form__field"
                                        placeholder="email address"
                                        required>
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group>
                                    <b-form-input
                                        v-model="form.password"
                                        type="password"
                                        class="tb-form-field login-form__field"
                                        placeholder="password"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <b-button type="submit" variant="primary" class="tb-button login-form__button">
                                LOGIN
                            </b-button>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    // import TbFooter from '@/views/Footer.vue';
    import {api} from "@/repository/repository.js";

    export default {
        components: {
            // TbFooter
        },
        data(){
            return{
                form:{
                    email:'',
                    password:''
                }
            }
        },
        methods:{
            onSubmit(){
                api.post('/login', this.form)
                    .then((response)=>{
                        // eslint-disable-next-line no-console
                        console.log(response);
                        let user = response.data;
                        this.$store.commit('setUser', user);
                        if(user.role == 'ADMIN'){
                            this.$router.push('/admin');
                        }else{
                            this.$router.push('/client');
                        }
                    })
                    .catch((error)=>{
                        // eslint-disable-next-line no-console
                        console.log(error.response);
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Error',
                            text: 'Incorrect login credentials',
                            duration: 10000
                        });
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    .home-wrapper {
        background: url("../assets/cabg.jpg");
        background-size: cover;
    }

    .full-height{
        height: 100vh;
    }

    a.router-link-active {
        color: white!important;
    }

    .logo {
        max-width: 100%;
    }

    .home__content {
        align-self: flex-end;
    }

    .home__bg {
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }

    .home__logo {
        text-align: center;
        //margin-bottom: 4rem;
        padding: 0 0.5rem;
        max-width: 30rem;
        margin: 0 auto 4rem auto;
    }

    .login-form {
        margin-bottom: 10vh;

        @media (min-width: 768px) {
            margin-bottom: 20vh;
        }

        display: flex;
        align-items: center;

        form {
            display: flex;
            flex-flow: column;
            align-items: center;
        }

        &__fields {
            display: flex;
            flex-flow: column;

            @media (min-width: 768px) {
                flex-flow: row;
            }
        }

        &__field {
            width: 18rem;
            margin: 0 0.5rem;
            padding: 2rem 1rem;
            @include font-body;
            //text-align: center!important;

            &::placeholder {
                text-align: center!important;
            }

            &:-webkit-autofill,
            &:-webkit-autofill:hover,
            &:-webkit-autofill:focus,
            &:-webkit-autofill:active {
                background-color: rgba(0, 0, 0, 0)!important;
            }
        }

        &__button {
            padding: 0.8rem 1rem;
            width: 18rem;
            margin: 1rem 0.5rem 0 0.5rem;
            font-weight: 200;
            background-color: $color-light-blue;
            color: $color-white;
            @include font-h3;

            &:hover {
                background-color: $color-dark-blue;
            }
        }
    }




    //.right-col{
    //    background: url("https://clubsaway.tbclient.co.uk/wp-content/uploads/2019/01/CAgolf.jpg");
    //    background-size: cover;
    //    display: flex;
    //    align-items: flex-start;
    //    justify-content: center;
    //
    //    .logo{
    //        margin-top: 3rem;
    //    }
    //}
    //.left-col{
    //    display: flex;
    //    flex-direction: column;
    //    justify-content: center;
    //    align-items: center;
    //
    //    .login-form{
    //        border:1px solid #e6e6e6;
    //        padding:2rem;
    //
    //        h1{
    //            margin: -2rem -2rem 2rem -2rem;
    //            padding: 1rem 2rem;
    //            border-bottom: 1px solid #e6e6e6;
    //            font-size: 2rem;
    //            font-weight: 100;
    //        }
    //    }
    //}
    //a.router-link-active {
    //    color: white!important;
    //}
    //
    //.logo {
    //    max-width: 300px;
    //}
</style>